import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/widget-utils';
import { getAnimation } from '../../../../../helpers';
import { useTheme } from '../../../../common';
import { usePlayer } from '../../../PlayerProvider';

export function VolumeControlIcon() {
  const { volume } = usePlayer();
  const { textColor } = useTheme();

  return (
    <Component>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-10 0 100 100"
        fill={getColorWithAlpha(textColor, 1)}
      >
        <path
          d="M63.4,71.6c-1.2,0-2.3-0.6-2.9-1.7c-0.9-1.6-0.4-3.7,1.2-4.6c5.5-3.2,8.9-9.1,8.9-15.4s-3.4-12.2-8.9-15.4 c-1.6-0.9-2.2-3-1.2-4.6c0.9-1.6,3-2.2,4.6-1.2c7.5,4.4,12.2,12.5,12.2,21.2s-4.7,16.8-12.2,21.2C64.6,71.5,64,71.6,63.4,71.6z"
          style={{ opacity: volume > 0.5 ? 1 : 0 }}
        />

        <path
          d="M57.1,60.7c-1.2,0-2.3-0.6-2.9-1.7c-0.9-1.6-0.4-3.7,1.2-4.6C57,53.5,58,51.8,58,50s-1-3.5-2.6-4.4 c-1.6-0.9-2.2-3-1.2-4.6c0.9-1.6,3-2.2,4.6-1.2c3.6,2.1,5.9,6,5.9,10.2s-2.3,8.1-5.9,10.2C58.2,60.5,57.7,60.7,57.1,60.7z"
          style={{ opacity: volume >= 0.001 ? 1 : 0 }}
        />

        <polygon
          points="85,40 80,35 70,45 60,35 55,40 65,50 55,60 60,65 70,55 80,65 85,60 75,50 "
          style={{ opacity: volume < 0.001 ? 1 : 0 }}
        />

        <path d="M44.2,24.3L28.7,36.6l-0.3,0.3H11.9c-1.1,0-1.9,0.9-1.9,1.9v22.3c0,1.1,0.9,1.9,1.9,1.9h16.4l0.3,0.3l15.5,12.4 c1.3,1,3.1,0.1,3.1-1.5V25.8C47.3,24.2,45.5,23.3,44.2,24.3z" />
      </svg>
    </Component>
  );
}

const Component = styled.div`
  & svg {
    display: flex;
  }

  & polygon,
  & path {
    opacity: 1;
    transition:
      ${getAnimation('opacity')}, ${getAnimation('fill', 'ease', 100)};
  }

  width: 24px;
  height: 24px;
`;
